module.exports = __webpack_public_path__ + "static/loading-img-ad7b457c67dd17fbdef9530ef6bb7282.gif";